import NotificationSound from "../assets/sounds/notification-sound.mp3";

const getNotificationSound = () => {
    return new Audio(NotificationSound);
};

export { getNotificationSound };
